// extracted by mini-css-extract-plugin
module.exports = {"button":"_2dtus","link":"_29Cve","orderInformation":"_2Wqs2","orderNumber":"_2weiY","placedOn":"_1NQOx","tickets":"_1_W-b","summaryDetails":"_21BcY","actions":"_30XFB"};